import React, { useState } from 'react';
import './LandingPage.css';
import churchCrest from '../assets/Mar_Thoma_Syrian_Church_Crest.png';
import API_BASE_URL from '../config/api';

const LandingPage = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const generateOtp = async () => {
    if (!email) {
      setError('Please enter your email');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${API_BASE_URL}/auth/generate-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });
      
      if (response.ok) {
        setShowOtpInput(true);
      } else if (response.status === 404) {
        setError('Your email is not registered with us. Please reach out to the church secretary to get your email added.');
      } else {
        setError('Failed to generate OTP. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  const submitOtp = async () => {
    if (!otp || otp.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }),
      });
      
      if (response.ok) {
        const data = await response.json();
        onLogin(data.token);
      } else {
        setError('Invalid OTP. Please try again.');
      }
    } catch (err) {
      setError('Network error. Please check your connection.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-container">
      <div className="background-overlay"></div>
      <div className="auth-card">
        <div className="church-header">
          <img src={churchCrest} alt="Church Crest" className="church-crest-icon" />
          <h1>St. Thomas Mar Thoma Church</h1>
          <h1>Marathahalli</h1>
          <p>Admin Portal</p>
        </div>
        
        {!showOtpInput ? (
          <div className="auth-form">
            <h2>Sign In</h2>
            <div className="input-group">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="auth-input"
              />
            </div>
            <button 
              onClick={generateOtp} 
              disabled={loading}
              className="auth-button primary"
            >
              {loading ? 'Generating...' : 'Generate OTP'}
            </button>
          </div>
        ) : (
          <div className="auth-form">
            <h2>Enter OTP</h2>
            <p className="otp-message">We've sent a 6-digit code to {email}</p>
            <div className="input-group">
              <input
                type="text"
                placeholder="Enter 6-digit OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                className="auth-input otp-input"
                maxLength="6"
              />
            </div>
            <button 
              onClick={submitOtp} 
              disabled={loading}
              className="auth-button primary"
            >
              {loading ? 'Verifying...' : 'Submit'}
            </button>
            <button 
              onClick={() => setShowOtpInput(false)}
              className="auth-button secondary"
            >
              Back
            </button>
          </div>
        )}
        
        {error && <div className="error-message">{error}</div>}
      </div>
    </div>
  );
};

export default LandingPage;
